import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=3f496e80"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports